import axios from "axios";
import { BASE, BASEMOCK} from "./url";
import { Service } from 'axios-middleware';
import jwt_decode from "jwt-decode";

export const authHeader = () => {
    let token = localStorage.getItem('t');
    if (token) {
      return {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json"
      };
    }
  };

export const api = axios.create({
    baseURL: BASE,
    headers: authHeader(),
    responseType: "json"
});
export const apiMock = axios.create({
    baseURL: BASEMOCK,
    responseType: "json"
});

api.interceptors.response.use(
    response => {
      if (response.status === 401 || response.status === 403) {
        localStorage.removeItem("t");
        window.location.href = "/sesion/caducada"
        return;
      }
      return response;
    },
    error => {
      if(error.response){
        if (error.response.status === 401 || error.response.status === 403) {
          localStorage.removeItem("t");
          window.location.href = "/sesion/caducada"
          return;
        }
      }    
  
      return Promise.reject(error);
    }
  );
  
  api.interceptors.request.use(
    request => {
      let token = localStorage.getItem('t');
      if (token !== null) {
        let token_data = jwt_decode(token);
        if (token_data.exp < Date.now() / 1000) {
          localStorage.removeItem("t");
          window.location.href = "/sesion/caducada"
          return;
        }
      }
      return request;
    },
    error => {
      return Promise.reject(error);
    }
  );
  
  /* const service = new Service(api);
  service.register({
    onResponse(resp) {
        console.log(resp)
      const { data: { data, message }, status } = resp
      let tmpResponse = ({ data, status, message })
      return tmpResponse;
    }
  }); */